/**
 * ChatDAGRAGDAG C2.1 sp3 — pure, layout-free child-lookup over the chat
 * Message list. Distinct from topologyWalk.ts's WalkCtx.childrenByParent
 * (ReactFlow-node/edge coupled): this operates on `Message.parent_ids` for
 * the LEFT-PANEL tree-view. No React, no api imports — unit-testable
 * without the Vite import.meta chain.
 */
import type { Message } from '../../contexts/ConversationContext';

/** parentId -> ordered child message ids (message order preserved). */
export function buildChildrenByParent(messages: Message[]): Map<string, string[]> {
  const cbp = new Map<string, string[]>();
  for (const m of messages) {
    const parent = (m.parent_ids ?? [])[0];
    if (!parent) continue; // root (no parent) — not a child of anything
    const arr = cbp.get(parent) ?? [];
    arr.push(m.id);
    cbp.set(parent, arr);
  }
  return cbp;
}

/** Message ids that have >1 child = fork points (a Camp spawned here). */
export function findForkPoints(messages: Message[]): string[] {
  const cbp = buildChildrenByParent(messages);
  const forks: string[] = [];
  for (const m of messages) {
    if ((cbp.get(m.id)?.length ?? 0) > 1) forks.push(m.id);
  }
  return forks;
}
